var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNinja(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 484.336 484.336",
    style: {
      enableBackground: "new 0 0 484.336 484.336"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#033F33"
    },
    d: "M124.064,215.816c3.2,7.048,0.072,15.336-6.976,18.528l0,0c-7.04,3.192-15.328,0.072-18.52-6.976 L46.56,112.608c-3.192-7.04-0.08-15.336,6.968-18.528l0,0c7.048-3.184,15.336-0.072,18.52,6.976L124.064,215.816z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DFE8E8"
    },
    d: "M52.56,91.952c-7.04,3.192-10.16,11.488-6.968,18.528l5.784,12.752l25.496-11.552l-5.768-12.752 C67.904,91.88,59.616,88.76,52.56,91.952z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C0CCCC"
    },
    d: "M76.864,111.672L71.096,98.92c-3.192-7.048-11.488-10.168-18.536-6.976 c-7.04,3.192-10.16,11.488-6.968,18.528"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.825,
    y: 130.062,
    transform: "matrix(-0.3515 0.9362 -0.9362 -0.3515 221.8192 113.8037)",
    style: {
      fill: "#C0CCCC"
    },
    width: 7.336,
    height: 7.336
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.813,
    y: 145.524,
    transform: "matrix(-0.3524 0.9358 -0.9358 -0.3524 245.7547 128.3178)",
    style: {
      fill: "#C0CCCC"
    },
    width: 7.336,
    height: 7.328
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.836,
    y: 160.997,
    transform: "matrix(-0.3528 0.9357 -0.9357 -0.3528 269.7415 142.7556)",
    style: {
      fill: "#C0CCCC"
    },
    width: 7.328,
    height: 7.336
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.818,
    y: 176.416,
    transform: "matrix(-0.3533 0.9355 -0.9355 -0.3533 293.6292 157.1716)",
    style: {
      fill: "#C0CCCC"
    },
    width: 7.344,
    height: 7.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.816,
    y: 191.823,
    transform: "matrix(-0.3524 0.9358 -0.9358 -0.3524 317.4922 171.2838)",
    style: {
      fill: "#C0CCCC"
    },
    width: 7.336,
    height: 7.336
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.827,
    y: 207.274,
    transform: "matrix(-0.3533 0.9355 -0.9355 -0.3533 341.4567 185.8267)",
    style: {
      fill: "#C0CCCC"
    },
    width: 7.344,
    height: 7.32
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C0CCCC"
    },
    d: "M156.016,211.216c1.816,4.032,0.032,8.768-3.984,10.592l-67.408,30.544 c-4.016,1.824-8.76,0.04-10.584-3.984l0,0c-1.832-4.032-0.048-8.768,3.984-10.592l67.4-30.544 C149.456,205.408,154.192,207.192,156.016,211.216L156.016,211.216z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A5B5B4"
    },
    d: "M156.016,211.216L156.016,211.216c1.816,4.032,0.032,8.768-3.984,10.592l-67.408,30.544 c-4.016,1.824-8.76,0.04-10.584-3.984l0,0"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 117.149,
    y: 231.82,
    transform: "matrix(-0.9108 0.4129 -0.4129 -0.9108 366.7305 461.7407)",
    style: {
      fill: "#033F33"
    },
    width: 32.657,
    height: 77.346
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#033F33"
    },
    d: "M360.272,215.816c-3.192,7.048-0.08,15.336,6.976,18.528l0,0c7.04,3.192,15.328,0.072,18.52-6.976 L437.776,112.6c3.192-7.04,0.08-15.336-6.968-18.528l0,0c-7.048-3.184-15.344-0.072-18.52,6.976L360.272,215.816z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DFE8E8"
    },
    d: "M431.776,91.952c7.04,3.192,10.168,11.488,6.96,18.528l-5.776,12.752l-25.504-11.552l5.776-12.752 C416.432,91.88,424.72,88.76,431.776,91.952z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C0CCCC"
    },
    d: "M407.464,111.672l5.776-12.752c3.192-7.048,11.488-10.168,18.536-6.976 c7.04,3.192,10.168,11.488,6.96,18.528"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.169,
    y: 130.052,
    transform: "matrix(0.3515 0.9362 -0.9362 0.3515 392.9139 -299.776)",
    style: {
      fill: "#C0CCCC"
    },
    width: 7.336,
    height: 7.336
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.184,
    y: 145.546,
    transform: "matrix(0.3505 0.9366 -0.9366 0.3505 403.3428 -283.189)",
    style: {
      fill: "#C0CCCC"
    },
    width: 7.336,
    height: 7.344
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.144,
    y: 160.895,
    transform: "matrix(0.3528 0.9357 -0.9357 0.3528 412.0898 -266.6585)",
    style: {
      fill: "#C0CCCC"
    },
    width: 7.328,
    height: 7.336
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.157,
    y: 176.398,
    transform: "matrix(0.3515 0.9362 -0.9362 0.3515 422.6757 -250.0489)",
    style: {
      fill: "#C0CCCC"
    },
    width: 7.336,
    height: 7.336
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.164,
    y: 191.941,
    transform: "matrix(0.3524 0.9358 -0.9358 0.3524 432.2622 -233.4746)",
    style: {
      fill: "#C0CCCC"
    },
    width: 7.336,
    height: 7.32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.155,
    y: 207.285,
    transform: "matrix(0.3515 0.9362 -0.9362 0.3515 442.5111 -216.91)",
    style: {
      fill: "#C0CCCC"
    },
    width: 7.336,
    height: 7.336
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C0CCCC"
    },
    d: "M328.32,211.216c-1.832,4.032-0.032,8.768,3.984,10.592l67.392,30.544 c4.04,1.824,8.776,0.04,10.6-3.984l0,0c1.832-4.032,0.048-8.768-3.984-10.592l-67.416-30.544 C334.88,205.408,330.144,207.192,328.32,211.216L328.32,211.216z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A5B5B4"
    },
    d: "M328.32,211.216L328.32,211.216c-1.832,4.032-0.032,8.768,3.984,10.592l67.392,30.544 c4.04,1.824,8.776,0.04,10.6-3.984l0,0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.505,
    y: 231.808,
    transform: "matrix(0.9108 0.4129 -0.4129 0.9108 142.9789 -120.7242)",
    style: {
      fill: "#033F33"
    },
    width: 32.657,
    height: 77.338
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.168,
    y: 250.168,
    style: {
      fill: "#054236"
    },
    width: 176,
    height: 176
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#076855"
    },
    points: "303.408,314.168 182.736,314.168 190.792,178.168 295.368,178.168 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#065646"
    },
    points: "303.424,278.696 255.616,376.432 182.752,178.168 295.376,178.168 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#14826D"
    },
    d: "M322.008,109.792c0-70.032-31.84-98.368-79.84-98.648v-0.032v0.016v-0.016v0.032 c-48,0.28-79.84,28.616-79.84,98.648s31.84,133.352,79.84,134.864v0.144c0,0,0-0.064,0-0.072c0,0.008,0,0.072,0,0.072v-0.144 C290.168,243.144,322.008,179.824,322.008,109.792z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#076855"
    },
    d: "M242.168,242.168v2.624c0,0,0-0.064,0-0.072c0,0.008,0,0.072,0,0.072v-0.144 c48-1.504,79.84-64.832,79.84-134.856s-31.84-98.368-79.84-98.648v-0.032v0.016v-0.016v-0.944"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M197.976,192.616c-0.2-0.224-0.312-0.376-0.312-0.376S197.736,192.456,197.976,192.616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00233F"
    },
    d: "M288.192,192.616c0.2-0.224,0.312-0.376,0.312-0.376S288.424,192.456,288.192,192.616z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#65C7EA"
    },
    cx: 158.504,
    cy: 292.968,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#65C7EA"
    },
    cx: 169.504,
    cy: 323.288,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#65C7EA"
    },
    cx: 180.504,
    cy: 353.592,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#65C7EA"
    },
    cx: 191.504,
    cy: 383.92,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#65C7EA"
    },
    cx: 202.488,
    cy: 414.248,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#65C7EA"
    },
    cx: 213.504,
    cy: 444.568,
    r: 5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#1982BC"
    },
    cx: 325.848,
    cy: 292.968,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#1982BC"
    },
    cx: 314.808,
    cy: 323.288,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#1982BC"
    },
    cx: 303.832,
    cy: 353.592,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#1982BC"
    },
    cx: 292.808,
    cy: 383.92,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#1982BC"
    },
    cx: 281.832,
    cy: 414.248,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#1982BC"
    },
    cx: 270.832,
    cy: 444.568,
    r: 5
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B967E"
    },
    d: "M461.272,303.792L339.72,261.52l2.568-7.008l-15.896-6.72c-6.344,28.728-41.584,50.712-84.216,50.712 c-42.648,0-77.872-22.032-84.208-50.76l-15.92,6.656l2.576,6.88L23.064,303.8L0,474.168h30.736h156.736H235h14.328h49.736h154.528 h30.736L461.272,303.792z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#14826D"
    },
    d: "M66.168,474.168h121.304H235h14.328h49.736h154.528h30.736l-23.064-170.376L339.712,261.52 l2.568-7.008l-15.896-6.72c-6.344,28.728-41.584,50.712-84.216,50.712c-42.648,0-77.872-22.032-84.208-50.76l-15.92,6.656 l2.576,6.88L23.064,303.8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#076855"
    },
    d: "M98.168,474.168h89.304H235h14.328h49.736h154.528h30.736l-23.064-170.376L339.712,261.52 l2.568-7.008l-15.896-6.72c-6.344,28.728-41.584,50.712-84.216,50.712c-42.648,0-77.872-22.032-84.208-50.76l-15.92,6.656 l3.688,7.36"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#065646"
    },
    d: "M234.168,474.168h15.168h49.736H453.6h30.736l-23.064-170.376L339.72,261.52l2.568-7.008 l-15.896-6.72c-6.344,28.728-42,51.176-84.64,51.176"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8A991"
    },
    d: "M309.944,118.944c0,10.616-30.344,33.88-67.784,33.88c-37.424,0-67.768-23.264-67.768-33.88 c0-10.624,30.344-0.912,67.768-0.912C279.6,118.024,309.944,108.32,309.944,118.944z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BDA0"
    },
    d: "M309.944,118.944c0,10.616-30.344,33.88-67.784,33.88c-37.424,0-67.768-23.264-67.768-33.88 c0-10.624,30.344,7.088,67.768,7.088C279.6,126.024,309.944,108.32,309.944,118.944z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8A991"
    },
    d: "M242.16,118.024c37.44,0,67.784-9.712,67.784,0.912c0,10.616-30.344,33.88-67.784,33.88"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DFE8E8"
    },
    d: "M282.168,78.168c0,15.464-12.536,28-28,28h-24c-15.464,0-28-12.536-28-28l0,0 c0-15.464,12.536-28,28-28h24C269.632,50.168,282.168,62.704,282.168,78.168L282.168,78.168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DFE8E8"
    },
    d: "M283.168,77.672c0,15.744,3.24,28.496-12.496,28.496h-57c-15.728,0-12.504-12.76-12.504-28.496l0,0 c0-15.744-3.216-28.496,12.504-28.496h57C286.408,49.168,283.168,61.928,283.168,77.672L283.168,77.672z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C0CCCC"
    },
    d: "M270.664,98.168h-57c-9.808,0-12.24-4.712-12.688-12.248c-0.344,11.56-0.064,20.248,12.696,20.248 h57c12.76,0,13.04-8.688,12.688-20.256C282.912,93.456,280.472,98.168,270.664,98.168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C0CCCC"
    },
    d: "M201.16,70.824c0-2.984-0.096-5.8-0.176-8.496c-0.208,3.576,0.008,7.768,0.12,12.248 C201.128,73.336,201.16,72.104,201.16,70.824z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C0CCCC"
    },
    d: "M283.16,70.824c0,1.28,0.048,2.504,0.08,3.752c0.112-4.488,0.328-8.672,0.12-12.24 C283.272,65.024,283.16,67.84,283.16,70.824z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C0CCCC"
    },
    points: "245.424,81.576 261.24,78.328 245.424,75.072 242.176,59.248 238.928,75.072  223.096,78.328 238.912,81.576 242.176,97.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DFE8E8"
    },
    d: "M227.96,361.944c-0.8,0.816-2.104,0.816-2.92,0.008l0,0c-0.8-0.816-0.8-2.128,0-2.928l31.328-31.32 c0.8-0.808,2.12-0.808,2.92,0l0,0c0.816,0.816,0.816,2.12,0,2.92L227.96,361.944z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DFE8E8"
    },
    d: "M256.36,361.944c0.816,0.816,2.12,0.816,2.92,0.008l0,0c0.816-0.816,0.816-2.128,0-2.928 l-31.312-31.32c-0.816-0.808-2.12-0.808-2.936,0l0,0c-0.8,0.816-0.8,2.12,0,2.92L256.36,361.944z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DFE8E8"
    },
    d: "M227.96,395.944c-0.8,0.816-2.104,0.816-2.92,0.008l0,0c-0.8-0.816-0.8-2.128,0-2.928l31.328-31.32 c0.8-0.808,2.12-0.808,2.92,0l0,0c0.816,0.816,0.816,2.12,0,2.92L227.96,395.944z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DFE8E8"
    },
    d: "M256.36,395.944c0.816,0.816,2.12,0.816,2.92,0.008l0,0c0.816-0.816,0.816-2.128,0-2.928 l-31.312-31.32c-0.816-0.808-2.12-0.808-2.936,0l0,0c-0.8,0.816-0.8,2.12,0,2.92L256.36,395.944z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DFE8E8"
    },
    d: "M227.96,429.944c-0.8,0.816-2.104,0.816-2.92,0.008l0,0c-0.8-0.816-0.8-2.128,0-2.928l31.328-31.32 c0.8-0.808,2.12-0.808,2.92,0l0,0c0.816,0.816,0.816,2.12,0,2.92L227.96,429.944z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DFE8E8"
    },
    d: "M256.36,429.944c0.816,0.816,2.12,0.816,2.92,0.008l0,0c0.816-0.816,0.816-2.128,0-2.928 l-31.312-31.32c-0.816-0.808-2.12-0.808-2.936,0l0,0c-0.8,0.816-0.8,2.12,0,2.92L256.36,429.944z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DFE8E8"
    },
    d: "M227.96,463.944c-0.8,0.816-2.104,0.816-2.92,0.008l0,0c-0.8-0.816-0.8-2.128,0-2.928l31.328-31.32 c0.8-0.808,2.12-0.808,2.92,0l0,0c0.816,0.816,0.816,2.12,0,2.92L227.96,463.944z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DFE8E8"
    },
    d: "M256.36,463.944c0.816,0.816,2.12,0.816,2.92,0.008l0,0c0.816-0.816,0.816-2.128,0-2.928 l-31.312-31.32c-0.816-0.808-2.12-0.808-2.936,0l0,0c-0.8,0.816-0.8,2.12,0,2.92L256.36,463.944z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNinja);
export default __webpack_public_path__ + "static/media/ninja.feae482d991938a5a2c4b86fd3814a1e.svg";
export { ForwardRef as ReactComponent };